import styled from 'styled-components';

export const EditLedgerContainer = styled.div`
  width: 100%;
  min-height: 500px;
  display: grid;
  grid-template-rows: 65px 1fr;

  & p {
    margin: 0;
  }
`;

export const materialStyles = {
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
    fontSize: '16px',
    fontWeight: '700',
    margin: '0',
  },
};
